import React from "react"
import styles from "./loader.css"

const Loader = ({ style = {} }) => {
  return <span className={"loadernew"} style={style}></span>
}

export default Loader
